module.exports = __webpack_public_path__ + "static/img/after_sale_starton-0.cf1996e1.png";